import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

export const Cursor = createSvgIcon(
    <svg
        viewBox="8 4 8 16"
        xmlns="http://www.w3.org/2000/svg"
        className="cursor"
    >
      <rect x="10" 
            y="6" 
            width="4" 
            height="12" 
            fill="#fff" 
      />
    </svg>,
  'Cursor'
);